import React, { Component } from 'react'

import { ThickMail } from '../../components/Icons'
import { Wrap, Label, InputContainer, StyledInput, IconContainer } from './styles'

class Input extends Component {
  render() {
    const { label, type, value, handleChange, placeholder, name, icon, dataKey, valid } = this.props

    return (
      <Wrap>
        {label ? <Label>{label}</Label> : null}

        <InputContainer>
          <StyledInput
            type={type}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            name={name}
            icon={icon}
            valid={valid}
            data-key={dataKey}
          />

          {icon === 'mail' ? (
            <IconContainer>
              <ThickMail size="" />
            </IconContainer>
          ) : null}
        </InputContainer>
      </Wrap>
    )
  }
}

export default Input



// WEBPACK FOOTER //
// ./src/components/Input/index.js